import type { Theme } from '../../types/theme';

export const voltagentTheme: Theme = {
  id: 'voltagent',
  name: 'VoltAgent',
  description: 'Void-black canvas with emerald accent, terminal-native AI agent framework',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/voltagent/DESIGN.md',
  visualKeywords: ['void-black', 'emerald accent', 'terminal-native', 'agent', 'framework'],
  colors: {
    background: '#030712',
    surface: '#0f172a',
    surfaceElevated: '#192134',
    textPrimary: '#ffffff',
    textSecondary: '#94a3b8',
    textMuted: '#94a3b8',
    border: '#1e293b',
    borderSubtle: '#283345',
    primary: '#10b981',
    primaryHover: '#1fc890',
    primaryActive: '#009b63',
    accent: '#10b981',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'technical',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
